import { Model } from ".";

export default class TruckType extends Model {
	get singularNoun() {
		return "truck type";
	}

	resource() {
		return "yard/trucks/types";
	}
}
